<script>
  export let section = 'Section';
  export let subsection = 'SubSection';
</script>

<div class="row">
  <div class="col-md-12 grid-margin">
    <div class="d-flex justify-content-between flex-wrap">
      <div class="d-flex align-items-end flex-wrap">
        <div class="mr-md-3 mr-xl-5">
          <h2>{section}</h2>
          <p class="mb-md-0">{subsection}</p>
        </div>
        <div class="d-flex">
          <i class="mdi mdi-home text-muted hover-cursor"></i>
          <p class="text-muted mb-0 hover-cursor">&nbsp;/&nbsp;{section}&nbsp;/&nbsp;</p>
          <p class="text-primary mb-0 hover-cursor">{subsection}</p>
        </div>
      </div>
      <div class="d-flex justify-content-between align-items-end flex-wrap">
        <slot>
        </slot>
      </div>
    </div>
  </div>
</div>